import { render, staticRenderFns } from "./BreakInDamageDescriptionStep.vue?vue&type=template&id=2b0daaa8&scoped=true"
import script from "./BreakInDamageDescriptionStep.vue?vue&type=script&lang=ts"
export * from "./BreakInDamageDescriptionStep.vue?vue&type=script&lang=ts"
import style0 from "./BreakInDamageDescriptionStep.vue?vue&type=style&index=0&id=2b0daaa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0daaa8",
  null
  
)

export default component.exports